'use strict'

export const OrderDocumentDefaultMaxFileSize = 5242880 // 5 MB
